module.exports = __webpack_public_path__ + "img/team-synergy.b3dfcaf6.jpg";